<template>
    <b-modal size="xl" centered hide-header hide-footer body-class="p-0" ref="geofences">
        <GeofenceData ref="geofence-data"></GeofenceData>
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img src="@/assets/img/geofences.svg">
                <p class="text-light m-0 fs-4 ms-2">Geocercas</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <ul class="list-group">
                <li class="list-group-item d-flex flex-row justify-content-between align-items-center" v-for="geofence in geofences" :key="geofence.id">
                    <div class="d-flex flex-row align-items-center">
                        <img :src="require('@/assets/img/geofences/' + (geofence.attributes?.icon || '0') + '.png')">
                        <p class="m-0 ms-2">{{ geofence?.name || 'GEOCERCA SIN NOMBRE' }}</p>
                    </div>
                    <div class="d-flex flex-row" style="gap: 5px;">
                        <!-- <div class="edit d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-edit" width="20" height="20" viewBox="0 0 24 24" stroke-width="0.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                <path d="M16 5l3 3" />
                            </svg>
                        </div> -->
                        <div class="delete d-flex" @click="deleteGeofence(geofence.attributes.name, geofence.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trash" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 7l16 0" />
                                <path d="M10 11l0 6" />
                                <path d="M14 11l0 6" />
                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                            </svg>
                        </div>
                    </div>
                </li>
            </ul>
            <b-button variant="primary" class="mt-3" @click="openGeofencesData">Crear Geocerca</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import GeofenceService from '@/api/services/geofence.service';
import geofencesModule from '@/store/modules/geofences.module';
import { Component, Vue } from 'vue-property-decorator';
import GeofenceData from './GeofenceData.vue';
import mapsModule from '@/store/modules/maps.module';

@Component({
    components: { GeofenceData }
})
export default class Geofences extends Vue {
    private readonly MODAL_REF = 'geofences'

    get geofences() {
        return geofencesModule.geofences || []
    }

    close() {
        const modal: any = this.$refs[this.MODAL_REF]
        modal.hide();
    }

    show() {
        const modal: any = this.$refs[this.MODAL_REF]
        modal.show();
    }

    openGeofencesData() {
        const modal: any = this.$refs['geofence-data']
        modal.show();
    }

    async deleteGeofence(geofenceName: string, geofenceId: number) {
        const result = await this.$bvModal.msgBoxConfirm(`Desea Eliminar la Geocerca: ${geofenceName}`, {
            title: 'Confirmar Acción',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'text-light',
            headerBgVariant: 'primary',
            okTitle: 'Aceptar',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
        if (result) {
            await GeofenceService.delete(geofenceId)
            const geofences = geofencesModule.geofences
            geofencesModule.setGeofences(geofences.filter(geofence => geofence.id !== geofenceId))
            mapsModule.mapService.updateGeofences()
        }
    }
}
</script>
<style lang="sass" scoped>
    @import '@/assets/style/variables.sass'
    @import '@/assets/style/modal-styles.sass'
    svg
        stroke: $secondary
        width: auto
        height: 25px
        stroke-width: 2px
    img
        height: 35px
    .delete
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(.9)
</style>